import * as moment from 'moment';
import * as Enum from '../models/enum';
import { Interval, IntervalUnit } from './Interval';

export class TimeInterval {
    interval: number;
    unit: Enum.TimeUnit;

   constructor(interval?: number, unit?: Enum.TimeUnit, allowEmpty?: boolean) {
        this.interval = (interval || interval === 0)
            ? interval
            : (allowEmpty)
                ? undefined
                : 1;
        this.unit = (unit || unit === 0)
            ? unit
            : (allowEmpty)
                ? undefined
                : Enum.TimeUnit.Day;
    }

    duration(): moment.Duration {
        const tu = this.getStringTimeUnit();
        return moment.duration(this.interval, tu);
    }

    toInterval(): Interval {
        return {
            interval: this.interval,
            unit: this.getStringTimeUnit()
        };
    }

    private getStringTimeUnit(): IntervalUnit {
        let pfiouh: IntervalUnit;

        switch (this.unit) {
            case Enum.TimeUnit.Second:
                pfiouh = 's';
                break;
            case Enum.TimeUnit.Minute:
                pfiouh = 'm';
                break;
            case Enum.TimeUnit.Hour:
                pfiouh = 'h';
                break;
            case Enum.TimeUnit.Day:
                pfiouh = 'd';
                break;
            case Enum.TimeUnit.Week:
                pfiouh = 'w';
                break;
            case Enum.TimeUnit.Month:
                pfiouh = 'M';
                break;
            case Enum.TimeUnit.Year:
                pfiouh = 'y';
                break;
        }

        return pfiouh;
    }
}